import { colors } from '@mui/material'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { ptBR } from '@mui/material/locale'

const theme = createTheme(
  {
    palette: {
      primary: {
        light: '#8D3D35',
        main: '#702826',
        dark: '#4F0C17',
      },
      secondary: {
        light: '#F6F1EB',
        main: '#B79266',
        dark: '#8C6A42',
        contrastText: '#FFFFFF',
      },
      info: {
        light: '#77A0b7',
        main: '#5689A6',
        dark: '#3C5F74',
        contrastText: '#FFFFFF',
      },
      grey: {
        200: '#EAEAEA',
      },
      text: {
        primary: colors.grey[800],
        secondary: colors.grey[50],
        disabled: colors.grey[800],
      },
      background: {
        paper: colors.grey[100],
        default: '#FFFFFF',
      },
    },
  },
  ptBR,
)

const defaultTheme = createTheme(theme, {
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          width: 260,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          ':hover': {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.secondary.dark,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.secondary.main,
          fontWeight: 'bold',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: theme.palette.secondary.main,
          fontSize: 14,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: theme.palette.secondary.main,
          fontSize: 14,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: 14,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          fontWeight: 500,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[400],
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: theme.palette.text.disabled,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .Mui-disabled': {
            backgroundColor: theme.palette.grey[200],
          },
          '& .MuiFormLabel-root': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .Mui-disabled': {
            backgroundColor: theme.palette.grey[200],
          },
        },
      },
    },
  },
})

export default responsiveFontSizes(defaultTheme)
